import * as pdfjs from "pdfjs-dist";

// createElement("video") では正常動作しないため、外部から渡す
export const previewVideo = (src: string, video: HTMLVideoElement, onReadMovieFileSize: (duration: number) => void) => {
  return new Promise<{ image: string; option?: { videoWidth: number; videoHeight: number } }>(resolve => {
    video.ondurationchange = () => {
      // 秒数を取得したい場合はここで取得する
      URL.revokeObjectURL(video.src);
      onReadMovieFileSize(video.duration);
    };
    video.onloadeddata = () => {
      // onloadeddata のタイミングでフレーム描画できるはずだができず、、oncanplay や oncanplaythrough も同様
      // https://developer.mozilla.org/ja/docs/Web/API/HTMLMediaElement/loadeddata_event
      // 苦肉の策で setInterval で描画できるまで繰り返す (最大 5 秒)
      let count = 0;
      const timer = setInterval(() => {
        count++;

        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext("2d");
        const dataURL0 = canvas.toDataURL();

        context!.drawImage(video, 0, 0, canvas.width, canvas.height);
        // src が外部URL の場合、 video.crossOrigin が "anonymous" でないと fail する
        const dataURL = canvas.toDataURL();

        // 5 秒間は最初のフレームが描画できていなければ繰り返す
        if (count < 100 && dataURL0 === dataURL) {
          return;
        }
        clearInterval(timer);

        resolve({ image: dataURL, option: { videoWidth: video.videoWidth, videoHeight: video.videoHeight } });
      }, 50);
    };
    video.src = src;
    video.load(); // iPhone の場合に onloadeddata を発火させるために必要
  });
};

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const previewPdf = async (data: ArrayBuffer): Promise<{ url: string; numPages: number }> => {
  const pdf = await pdfjs.getDocument({
    data: data,
    cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
    cMapPacked: true,
  }).promise;

  // 1ページ目をcanvasにレンダリング
  const page = await pdf.getPage(1);
  const canvas = document.createElement("canvas");
  const viewport = page.getViewport({ scale: 1 });
  canvas.height = viewport.height;
  canvas.width = viewport.width;
  const context = canvas.getContext("2d")!;
  const task = page.render({
    canvasContext: context,
    viewport: viewport,
  });
  await task.promise;

  return {
    url: canvas.toDataURL(),
    numPages: pdf.numPages,
  };
};

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    previewVideo: (
      src: string,
      video: HTMLVideoElement,
      onReadMovieFileSize: (duration: number) => void,
    ) => Promise<{ image: string; option?: { videoWidth: number; videoHeight: number } }>;
    previewPdf: (data: ArrayBuffer) => Promise<{ url: string; numPages: number }>;
  }
}
